import { LocationManagementLocationKind } from "./locationKind";
import { LocationManagementLocationType } from "./locationType";

export type LocationManagementLocation = {
  id?: string;
  organizationId?: string | number | null;
  organizationName?: string | null;
  name: string;
  code: string;
  locationTypeId: string | null;
  locationKindId: string | null;
  description: string;
  parentId?: string | null;
  warehouseId?: number | null;
  warehouse?: boolean;
  parent?: { id: string; code: string } | null;
  locationType?: LocationManagementLocationType | null;
  locationKind?: LocationManagementLocationKind | null;
  movable?: boolean;
  path?: string;
  childrenCount?: number;
  inventoriesCount?: number;
  ancestors?: LocationLink[];
  createdAt?: string;
};

export type LocationLink = {
  id: string | number;
  code: string;
  childrenCount?: number;
  inventoriesCount?: number;
};

export const defaultLocationManagementLocation: LocationManagementLocation = {
  name: "",
  code: "",
  locationTypeId: "",
  locationKindId: null,
  description: "",
  parentId: null,
};
